import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJDUVList.css';

function DJDUVList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJDUV,
    } = functions;

    const { DJDUVListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJDUVList-container">
            {DJDUVListData.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>
                    No tiene ninguna Declaración de División/Unificación de
                    Viñedo
                </h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="DJDUVList-footer">
                    <form onSubmit={handleSubmit(newDJDUV)}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva DJDUV
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DJDUVList;
